export default {
  'clients/client': 13,
  'sales_bpm/salesbpm': 23,
  'task_manager/task': 35,
  'contacts/contact': 64,
}
